(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["aadil-v5-collections"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('aadil-product-row'))customElements.define('aadil-product-row',class extends HTMLElement{connectedCallback(){if(this.ready)return;this.ready=true;const track=this.querySelector('.av5-product-track'),controls=this.querySelector('.av5-row-controls'),buttons=[...controls.querySelectorAll('button')];this.sync=()=>{controls.hidden=track.scrollWidth<=track.clientWidth+2;buttons[0].disabled=track.scrollLeft<2;buttons[1].disabled=track.scrollLeft+track.clientWidth>=track.scrollWidth-2};buttons.forEach(b=>b.addEventListener('click',()=>track.scrollBy({left:Number(b.dataset.direction)*track.clientWidth*.85,behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'instant':'smooth'})));track.addEventListener('scroll',this.sync,{passive:true});this.observer=new ResizeObserver(this.sync);this.observer.observe(track);this.sync()}disconnectedCallback(){this.observer?.disconnect();this.ready=false}});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["aadil-v5-giveaway"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('aadil-giveaway'))customElements.define('aadil-giveaway',class extends HTMLElement{connectedCallback(){if(this.ready)return;this.ready=true;const dialog=this.querySelector('dialog'),form=this.querySelector('form'),status=this.querySelector('[role="status"]'),submit=form.querySelector('[type="submit"]'),dob=form.elements.date_of_birth;const today=new Date();dob.max=[today.getFullYear(),String(today.getMonth()+1).padStart(2,'0'),String(today.getDate()).padStart(2,'0')].join('-');const open=()=>{if(!dialog.open)dialog.showModal()},dismiss=()=>{try{sessionStorage.setItem('aadil-giveaway-dismissed','1')}catch{}};this.querySelector('[data-open]').addEventListener('click',open);this.querySelector('[data-close]').addEventListener('click',()=>dialog.close());dialog.addEventListener('close',dismiss);dialog.addEventListener('click',e=>{if(e.target===dialog){const r=dialog.getBoundingClientRect();if(e.clientX<r.left||e.clientX>r.right||e.clientY<r.top||e.clientY>r.bottom)dialog.close()}});let seen=false;try{seen=sessionStorage.getItem('aadil-giveaway-dismissed')==='1'}catch{}if(!seen)this.timer=setTimeout(()=>{if(!document.querySelector('dialog[open]')&&!document.querySelector('cart-drawer.active'))open()},Number(this.dataset.delay)||18000);form.elements.phone.addEventListener('input',()=>form.elements.phone.setCustomValidity(''));dob.addEventListener('input',()=>dob.setCustomValidity(''));form.addEventListener('submit',async e=>{e.preventDefault();if(this.pending)return;const endpoint=this.dataset.endpoint;if(!endpoint||!/^\/apps\/[a-zA-Z0-9/_-]+$/.test(endpoint)){return}const digits=form.elements.phone.value.replace(/\D/g,'');const national=digits.length===12&&digits.startsWith('91')?digits.slice(2):digits.replace(/^0/,'');if(!/^[6-9]\d{9}$/.test(national)){form.elements.phone.setCustomValidity(this.dataset.phoneError);form.reportValidity();return}if(!dob.value||dob.value>dob.max||dob.value<'1900-01-01'){dob.setCustomValidity(this.dataset.dobError);form.reportValidity();return}if(!form.reportValidity())return;this.pending=true;submit.disabled=true;const label=submit.textContent;submit.textContent=this.dataset.submitting;status.textContent='';const controller=new AbortController();const timeout=setTimeout(()=>controller.abort(),15000);try{const response=await fetch(endpoint,{method:'POST',headers:{'Content-Type':'application/json'},credentials:'same-origin',signal:controller.signal,body:JSON.stringify({campaign:'aadil-60-tshirts',name:form.elements.name.value.trim(),phone:'+91'+national,date_of_birth:dob.value,city:form.elements.city.value.trim(),consent_purpose:'giveaway_entry_and_winner_contact',marketing_consent:false})});const result=await response.json();if(!response.ok||result.success!==true||!result.entry_id)throw new Error('not_saved');status.textContent=this.dataset.success;form.reset();submit.hidden=true;try{sessionStorage.setItem('aadil-giveaway-dismissed','1')}catch{}}catch{status.textContent=this.dataset.error}finally{clearTimeout(timeout);this.pending=false;submit.disabled=false;submit.textContent=label}})}disconnectedCallback(){clearTimeout(this.timer)}});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["aadil-v5-reels"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('aadil-instagram-reel'))customElements.define('aadil-instagram-reel',class extends HTMLElement{connectedCallback(){if(this.ready)return;this.ready=true;this.querySelector('button')?.addEventListener('click',()=>{let url;try{url=new URL(this.dataset.url)}catch{return}const match=url.pathname.match(/^\/(?:reel|p)\/([A-Za-z0-9_-]+)\/?$/);if(!['www.instagram.com','instagram.com'].includes(url.hostname)||!match)return;const frame=document.createElement('iframe');frame.src='https://www.instagram.com/reel/'+match[1]+'/embed/';frame.title=this.dataset.title||'Instagram';frame.allow='encrypted-media; fullscreen; picture-in-picture';frame.referrerPolicy='strict-origin-when-cross-origin';frame.loading='lazy';this.replaceChildren(frame)})}});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
